import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TemplateEffects } from './state/template.effects';
import { templateFeature } from './state/template.feature';

export const TEMPLATE_STORE_PROVIDERS = {
  feature: provideState(templateFeature),
  effects: provideEffects(TemplateEffects),
};
